import { Center } from '@/components/center';
import { InvitationMessage } from '@/pages/invitation-accept/invitation-message';

const PendingInvitation = () => (
  <Center>
    <InvitationMessage title='Invitation not found'>
      This invitation isn’t available. Ask whoever invited you to send it again.
    </InvitationMessage>
  </Center>
);

export { PendingInvitation };
